import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';


const CollegeGraduationYear = ({ classes, user, obfuscateView }) => {
  if (user) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.college_graduation_year"/></strong>
        {!obfuscateView && <p>{get(user, 'college_graduation_year')}</p>}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
}

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
  },
};

export default withStyles(styles)(CollegeGraduationYear);